export default __webpack_public_path__ + "static/media/lightmode-icon.2ede19e5.svg";